import { ApolloClient } from '@apollo/client';
import type { Unmasked } from '@apollo/client/masking';
import { CategoriesQuery, StaticFooterDataQuery } from '../../graphql/graphql';
import { getStaticFooterData, getCategories } from '../../api/queries';

export const getStaticData = async (
  apolloClient: ApolloClient<unknown>,
  withCategories = false
) => {
  if (typeof window === 'undefined' && process.env.NEXT_PUBLIC_E2E === '1') {
    const { readMockFile } = await import('./readMockFile');
    const footerMock = await readMockFile<{
      data: Unmasked<StaticFooterDataQuery>;
    }>('staticFooterMockData.json');

    apolloClient.cache.writeQuery({
      query: getStaticFooterData,
      data: footerMock.data
    });

    if (withCategories) {
      const categoriesMock = await readMockFile<{
        data: Unmasked<CategoriesQuery>;
      }>('main_page/categoriesQueryMockData.json');

      apolloClient.cache.writeQuery({
        query: getCategories,
        data: categoriesMock.data
      });
    }

    return;
  }

  try {
    await apolloClient.query<StaticFooterDataQuery>({
      query: getStaticFooterData
    });

    if (withCategories) {
      await apolloClient.query<CategoriesQuery>({
        query: getCategories
      });
    }
  } catch (e) {
    console.error(e);
  }
};
